export enum ControlSize {
  "Large" = "Large",
  "Midium" = "Midium",
  "Small" = "Small",
}
